import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import ar from './ar.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar }
    },
    fallbackLng: 'ar',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

// Load admin content overrides and deep-merge them over the bundled defaults,
// so any UI text edited in the admin dashboard takes effect site-wide.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
fetch(`${BACKEND_URL}/api/translations`)
  .then((res) => (res.ok ? res.json() : null))
  .then((data) => {
    if (!data) return;
    let changed = false;
    ['en', 'ar'].forEach((lng) => {
      const overrides = data[lng];
      if (overrides && typeof overrides === 'object' && Object.keys(overrides).length) {
        // deep merge (true) + overwrite existing keys (true)
        i18n.addResourceBundle(lng, 'translation', overrides, true, true);
        changed = true;
      }
    });
    if (changed) {
      // Force components using useTranslation to re-render with the new strings.
      i18n.changeLanguage(i18n.language);
    }
  })
  .catch(() => {});

export default i18n;
